import React from 'react';

export default function DeerTailSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="21.61,16.36 9.12,16.36 9.12,3.87 21.61,3.87" fill="#C7B0C7" />
      <polygon points="9.12,16.36 21.61,16.36 17.86,14.49 5.37,14.49" fill="#9C749C" opacity="0.95" />
      <polygon points="9.12,16.36 5.37,14.49 5.37,2.0 9.12,3.87" fill="#9C749C" opacity="0.95" />
      <polygon points="28.7,31.6 9.97,31.6 12.62,24.09 31.35,24.09" fill="#C7B0C7" />
      <polygon points="8.65,8.86 27.38,8.86 31.35,24.09 12.62,24.09" fill="#F1EBF1" opacity="0.92" />
      <polygon points="9.97,31.6 6.0,16.36 8.65,8.86 12.62,24.09" fill="#9C749C" opacity="0.95" />
      <polygon points="4.2,12.61 29.18,12.61 35.8,38.0 10.82,38.0" fill="#F1EBF1" opacity="0.92" />
      <polygon points="27.57,34.8 15.08,34.8 16.4,31.05 28.89,31.05" fill="#C7B0C7" />
      <polygon points="15.08,25.97 27.57,25.97 28.89,31.05 16.4,31.05" fill="#F1EBF1" opacity="0.92" />
      <polygon points="15.08,34.8 13.76,29.72 15.08,25.97 16.4,31.05" fill="#9C749C" opacity="0.95" />
      <polygon points="27.57,34.8 15.08,34.8 16.4,31.05 28.89,31.05" fill="#C7B0C7" />
      <polygon points="15.08,25.97 27.57,25.97 28.89,31.05 16.4,31.05" fill="#F1EBF1" opacity="0.92" />
      <polygon points="15.08,34.8 13.76,29.72 15.08,25.97 16.4,31.05" fill="#9C749C" opacity="0.95" />
    </svg>
  );
}
